import { LabelDialogType } from '@tableau/catalog-ui-temp';
import _ = require('underscore');

import { assertUnreachable } from '~src/commonInfra/utils/TypescriptHelpers';

const INDICATOR_MAXIMUM_MESSAGE_LENGTH: number = 4000;

export type IllegalLabel = 'TOOLONG' | 'NOMESSAGE';

export type SubmitLabelCommand = IllegalLabel | 'SUBMIT' | 'DELETE';

export function emptyMessageAllowed(dialogType: LabelDialogType): boolean {
  switch (dialogType) {
    case 'certification': return false;
    case 'sensitivity': return true;
    case 'EXTRACT_REFRESH_FAILURE': return true;
    case 'FLOW_RUN_FAILURE': return true;
    case 'warning': return false;
    default:
      assertUnreachable(dialogType);
  }
}

export function canSubmitLabel(params:
  { message: string, active: boolean, category: LabelDialogType}): SubmitLabelCommand {
  const { message, active, category: dialogType } = params;

  if (message.length > INDICATOR_MAXIMUM_MESSAGE_LENGTH) {
    return 'TOOLONG';
  }

  if (_.isEmpty(message.trim())) {
    if (!active){
      return 'DELETE';
    }
    return emptyMessageAllowed(dialogType) ? 'SUBMIT' : 'NOMESSAGE';
  }

  return 'SUBMIT';
}
